var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "projectStep" }, [
    _c(
      "div",
      {
        staticClass: "step step1_active",
        attrs: { title: _vm.$t("updateNewSip.goTip") },
        on: {
          click: function ($event) {
            return _vm.toCurrentStep(0)
          },
        },
      },
      [
        _c("span"),
        _c("h3", [_vm._v(_vm._s(_vm.$t("deviceSip.projectConfig")))]),
      ]
    ),
    _c(
      "div",
      {
        staticClass: "step",
        class: _vm.stepTwoClass,
        attrs: { title: _vm.$t("updateNewSip.goTip") },
        on: {
          click: function ($event) {
            return _vm.toCurrentStep(1)
          },
        },
      },
      [
        _vm._l(9, function (i) {
          return _c("i", { key: i })
        }),
        _c("span"),
        _c("h3", [_vm._v(_vm._s(_vm.$t("deviceSip.areaConfig")))]),
      ],
      2
    ),
    _c(
      "div",
      {
        staticClass: "step",
        class: _vm.stepThreeClass,
        attrs: { title: _vm.$t("updateNewSip.goTip") },
        on: {
          click: function ($event) {
            return _vm.toCurrentStep(2)
          },
        },
      },
      [
        _vm._l(9, function (i) {
          return _c("i", { key: i })
        }),
        _c("span"),
        _c("h3", [
          _vm._v(
            " " +
              _vm._s(_vm.$t("deviceSip.deviceConfig")) +
              "&" +
              _vm._s(_vm.$t("deviceSip.exportConfig")) +
              " "
          ),
        ]),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }